let raf = null
let idle = null
let tick = null
let readTickInProgress = false
let writeTickInProgress = false

let rafReadArgs = []
let rafReadCallbacks = []

let rafWriteArgs = []
let rafWriteCallbacks = []

let rafReadNextArgs = []
let rafReadNextCallbacks = []

let rafWriteNextArgs = []
let rafWriteNextCallbacks = []

const idleReadArgs = []
const idleReadCallbacks = []

const idleWriteArgs = []
const idleWriteCallbacks = []

const tickReadArgs = []
const tickReadCallbacks = []

const tickWriteArgs = []
const tickWriteCallbacks = []

const canIdle = !!globalThis.requestIdleCallback

export function readDom(callback, ...args) {
  pullRafRead(callback)
  pullRafReadNext(callback)
  pullIdleRead(callback)
  pullTickRead(callback)

  rafReadArgs.push(args)
  rafReadCallbacks.push(callback)

  scheduleRaf()
}

export function writeDom(callback, ...args) {
  pullRafWrite(callback)
  pullRafWriteNext(callback)
  pullIdleWrite(callback)
  pullTickWrite(callback)

  rafWriteArgs.push(args)
  rafWriteCallbacks.push(callback)

  scheduleRaf()
}

export function readDomNext(callback, ...args) {
  pullRafReadNext(callback)
  pullIdleRead(callback)
  pullTickRead(callback)

  rafReadNextArgs.push(args)
  rafReadNextCallbacks.push(callback)

  scheduleRaf()
}

export function writeDomNext(callback, ...args) {
  pullRafWriteNext(callback)
  pullIdleWrite(callback)
  pullTickWrite(callback)

  rafWriteNextArgs.push(args)
  rafWriteNextCallbacks.push(callback)

  scheduleRaf()
}

export function readDomIdle(callback, ...args) {
  if (!canIdle) {
    return readDomTick(callback, ...args)
  }

  pullIdleRead(callback)
  pullTickRead(callback)

  idleReadArgs.push(args)
  idleReadCallbacks.push(callback)

  scheduleIdle()
}

export function writeDomIdle(callback, ...args) {
  if (!canIdle) {
    return writeDomTick(callback, ...args)
  }

  pullIdleWrite(callback)
  pullTickWrite(callback)

  idleWriteArgs.push(args)
  idleWriteCallbacks.push(callback)

  scheduleIdle()
}

export function readDomTick(callback, ...args) {
  if (readTickInProgress) {
    return rescheduleReadTick(callback, args)
  }

  pullTickRead(callback)

  tickReadArgs.push(args)
  tickReadCallbacks.push(callback)

  scheduleTick()
}

export function writeDomTick(callback, ...args) {
  if (writeTickInProgress) {
    return rescheduleWriteTick(callback, args)
  }

  pullTickWrite(callback)

  tickWriteArgs.push(args)
  tickWriteCallbacks.push(callback)

  scheduleTick()
}

export function cancelFastDom(callback) {
  pullRafRead(callback)
  pullRafWrite(callback)
  pullRafReadNext(callback)
  pullRafWriteNext(callback)
  pullIdleRead(callback)
  pullIdleWrite(callback)
  pullTickRead(callback)
  pullTickWrite(callback)
}

function scheduleRaf() {
  if (raf !== null) {
    return
  }

  if (!rafReadCallbacks.length && !rafWriteCallbacks.length && !rafReadNextCallbacks.length && !rafWriteNextCallbacks.length) {
    return
  }

  raf = requestAnimationFrame(callbackRaf)
}

function callbackRaf() {
  while (rafReadCallbacks.length) {
    const args = rafReadArgs.pop()
    const callback = rafReadCallbacks.pop()
    callback(...args)
  }

  readTickInProgress = false

  while (rafWriteCallbacks.length) {
    const args = rafWriteArgs.pop()
    const callback = rafWriteCallbacks.pop()
    callback(...args)
  }

  raf = null
  writeTickInProgress = false

  if (rafReadNextCallbacks.length) {
    rafReadArgs = rafReadArgs.concat(rafReadNextArgs)
    rafReadCallbacks = rafReadCallbacks.concat(rafReadNextCallbacks)
    rafReadNextArgs = []
    rafReadNextCallbacks = []
  }

  if (rafWriteNextCallbacks.length) {
    rafWriteArgs = rafWriteArgs.concat(rafWriteNextArgs)
    rafWriteCallbacks = rafWriteCallbacks.concat(rafWriteNextCallbacks)
    rafWriteNextArgs = []
    rafWriteNextCallbacks = []
  }

  scheduleRaf()
}

function scheduleIdle() {
  if (idle !== null) {
    return
  }

  if (!idleReadCallbacks.length && !idleWriteCallbacks.length) {
    return
  }

  idle = requestIdleCallback(callbackIdle)
}

function callbackIdle() {
  while (idleReadCallbacks.length) {
    const args = idleReadArgs.pop()
    const callback = idleReadCallbacks.pop()
    callback(...args)
  }

  readTickInProgress = false

  while (idleWriteCallbacks.length) {
    const args = idleWriteArgs.pop()
    const callback = idleWriteCallbacks.pop()
    callback(...args)
  }

  idle = null
  writeTickInProgress = false

  scheduleIdle()
}

function scheduleTick() {
  if (tick !== null) {
    return
  }

  if (!tickReadCallbacks.length && !tickWriteCallbacks.length) {
    return
  }

  tick = setTimeout(callbackTick, 100)
}

function callbackTick() {
  readTickInProgress = true
  writeTickInProgress = true

  while (tickReadCallbacks.length) {
    const args = tickReadArgs.pop()
    const callback = tickReadCallbacks.pop()
    rescheduleReadTick(callback, args)
  }

  while (tickWriteCallbacks.length) {
    const args = tickWriteArgs.pop()
    const callback = tickWriteCallbacks.pop()
    rescheduleWriteTick(callback, args)
  }

  tick = null
}

function rescheduleReadTick(callback, args) {
  if (canIdle) {
    readDomIdle(callback, ...args)
  } else {
    readDom(callback, ...args)
  }
}

function rescheduleWriteTick(callback, args) {
  if (canIdle) {
    writeDomIdle(callback, ...args)
  } else {
    writeDom(callback, ...args)
  }
}

function pullRafRead(callback) {
  pullFrom(callback, rafReadArgs, rafReadCallbacks)
}

function pullRafReadNext(callback) {
  pullFrom(callback, rafReadNextArgs, rafReadNextCallbacks)
}

function pullRafWrite(callback) {
  pullFrom(callback, rafWriteArgs, rafWriteCallbacks)
}

function pullRafWriteNext(callback) {
  pullFrom(callback, rafWriteNextArgs, rafWriteNextCallbacks)
}

function pullIdleRead(callback) {
  pullFrom(callback, idleReadArgs, idleReadCallbacks)
}

function pullIdleWrite(callback) {
  pullFrom(callback, idleWriteArgs, idleWriteCallbacks)
}

function pullTickRead(callback) {
  pullFrom(callback, tickReadArgs, tickReadCallbacks)
}

function pullTickWrite(callback) {
  pullFrom(callback, tickWriteArgs, tickWriteCallbacks)
}

function pullFrom(callback, argsList, callbacks) {
  const index = callbacks.indexOf(callback)

  if (index === -1) {
    return
  }

  argsList.splice(index, 1)
  callbacks.splice(index, 1)
}
